const isMobile = window.screen.width < 768;

window.registerWizzyEvent = (eventName, callback) => {
 // return;
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents[eventName],
    function (payload = null) {
      try{
      return callback(payload);  
      }catch(e){
        console.log(e,'<=====wizzyError')
      }
      return payload;
      
    }
  );
};

window.changeWizzyTemplate=(name)=>{
    let newDiv = document.getElementById(name+"-new").text;
    let oldDiv = document.getElementById(name)
    oldDiv.text = newDiv;
  }


const overrideWizzyTemplates=()=>{
  let templates=[
    'wizzy-autocomplete-topproducts',
    'wizzy-search-results-product'
  ];
  templates.forEach((t)=>{
    window.changeWizzyTemplate(t);
  });
}

const setCollectionDescriptions = (collection) => {
  // console.log("collection data =====>", collection);
  // let description = collection.body_html;

  // let htmlToAdd = [
  //   '<div class="wizzy-collection-description-wrapper">',
  //   description,
  //   "</div>",
  // ].join("");
  // $(htmlToAdd).insertBefore("#shopify-section-footer");
  // $(".main-content").append(htmlToAdd);

 
  
};

const setCollectionTitle= (data=null)=>{
  let existingTitle = $('.collection-title-section.spaced-section.wizzy-collection-title');
  if (!window.wizzyConfig.common.isCategoryTitleLoaded && !existingTitle.length && data && typeof data == "object" && data.data.api == "filter" && window.wizzyConfig.common.isOnCategoryPage) {
    
    let titleHtml = $('#wizzy-collection-title').html();
    let titleEle= $(titleHtml);
    $('[data-page-wrapper]').prepend(titleHtml);
    //window.wizzyConfig.common.isCategoryTitleLoaded=true;
    console.log(data,'<====datasetCollectionTitle');
  }
 
}
const fetchCollectionDiscription = (collectionData) => {
  
  // let titleHtml = $('#wizzy-collection-title').html();
  // let titleEle= $(titleHtml);
  // console.log("====Collection Title Fetched ====>");
  //  $('[data-page-wrapper]').prepend(titleHtml);
  // console.log($('[data-page-wrapper]').length)
  // setCollectionDescriptions(titleEle);
  // console.log("====Collection title Added====>");
  // let url =
  //   [window.location.origin, "collections", collectionHandle].join("/") +
  //   ".json";
  // console.log("collection url=========>", url);
  // fetch(url)
  //   .then((res) => res.json())
  //   .then((res) => setCollectionDescriptions(res.collection));
};

window.onWizzyScriptLoaded = () => {
  overrideWizzyTemplates();

  $('body').on('click','.wizzy-header-search',(e)=>{
    $('.wizzy-search-modal-input .wizzy-custom-searchbox').click();
  });
  registerWizzyEvent("BEFORE_INIT", (payload) => {
    console.log(">======");
    payload.common.isCategoryTitleLoaded=false;
    let wizzyCollectionConfig = $("[wizzy-collection-config]");
    let currentTemplate = wizzyCollectionConfig.attr("template");
    
    if (payload.common.isOnCategoryPage) {
      let collectionData = JSON.parse($("[wizzy-collection-data]").val());
      fetchCollectionDiscription(collectionData);
     
      // payload.common.lazyDOMConfig.contentDOMIdentifiers = [
      //   "#wizzy-shopify-collection-page-wrapper",
      // ];
    }
      // payload.pageStore.isNumberPaginating = true;
    payload.common.lazyDOMConfig.searchInputIdentifiers = [];
    if (isMobile) {
      payload.common.lazyDOMConfig.searchInputIdentifiers.push({
      dom: ".wizzy-custom-searchbox",
      type: "text",
    });
      
    }else{
      payload.common.lazyDOMConfig.searchInputIdentifiers.push({
      dom: ".wizzy-custom-searchbox",
      type: "text",
    })
    }

    if (isMobile)
      payload.search.configs.pagination.infiniteScrollOffset = {
        desktop: 800,
        mobile: 1600,
      };
    return payload;
  });
  registerWizzyEvent("PRODUCTS_RESULTS_RENDERED", (payload = null) => {
    if (isMobile)
      document.querySelector(".wizzy-search-back .wizzy-icon").click();
    // document.documentElement.scrollTop = 0;
  //  checkWishListedItem();

    const reviews = document.getElementsByClassName(
      "wizzy-product-item-reviews-judgeme"
    );
    for (let i = 0; i < reviews.length; i++) {
      reviews[i].innerHTML = reviews[i].getAttribute("reviews");
    }

    // return payload;
  });
  let isTitleLoaded=false;
  registerWizzyEvent("VIEW_RENDERED", (payload) =>{
      
        setCollectionTitle(payload);
        if(isMobile && payload.data.api=='search'){
      $('.wizzy-search-back')[0].click();
    }
        return payload;
  });
  registerWizzyEvent("AFTER_PRODUCTS_TRANSFORMED", (payload) => {
    //  console.log(payload, "after products transform");
    payload.forEach((item) => {
      item.attributes.forEach((attribute) => {
        if (attribute.id === "product_badge_judgeme") {
          item.reviews = attribute.values[0].value[0];
        }

        if (attribute.id === "product_handle") {
          item.handle = attribute.values[0].value[0];
        }
        // item.flitsEmail = window.flitsObjects.storeData.customer_email
        //   ? window.flitsObjects.storeData.customer_email
        //   : "";
        // item.flitsId = window.flitsObjects.storeData.customer_id
        //   ? window.flitsObjects.storeData.customer_id
        //   : "";
      });
    });
    return payload;
  });
  registerWizzyEvent("BEFORE_RENDER_RESULTS", (payload) => {
    if (payload.api == "filter") {
      if (window.wizzyConfig.common.isOnCategoryPage) {
        if (
          payload.response.payload.filters.facets.hasOwnProperty("categories")
        ) {
          delete payload.response.payload.filters.facets.categories;
        }
      }
    }
    return payload;
  });
  registerWizzyEvent("BEFORE_FILTERS_EXECUTED", (payload) => {
    let filters = payload.filters;
    if (typeof filters == "string") filters = JSON.parse(filters);
    
     if (window.wizzyConfig.common.isOnCategoryPage && !$('body').hasClass('wizzy-search-results-rendered')){
       filters.sort.forEach((sort)=>{
         if(sort.field=='product_published_at:datetime'){
           sort.field='createdAt';
           console.log("sort=====>",sort);
         }
       })
     }
    //   filters.sort = [
    //     {
    //       field: [
    //         "product",
    //         window.wizzyConfig.common.categoryUrlKey,
    //         "sortOrder",
    //       ].join("_"),
    //       order: "asc",
    //     },

    //     {
    //       field: "relavance",
    //       order: "asc",
    //     },
    //   ];
    //console.log(filters, "<======BEFORE_FILTERS_EXECUTED filters");
    return payload;
  });
  $(".button.hover-animation").on("click", function () {
    console.log("check");
    if ($(this).val() === "Checkout") {
      $("form.form.cart-form.grid").submit();
    }
  });

  function checkWishListedItem() {
    $.ajax({
      type: "GET",
      url: `https://www.beatitude.in/apps/flits/api/1/15545/wishlist?customer_id=${window.flitsObjects.storeData.customer_id}&customer_hash=${window.flitsObjects.global.customerHash}&token=${window.flitsObjects.global.token}`,
      success: function (response) {
        let wishlistedProductData = response.data;
        wishlistedProductData.forEach((item) => {
          let id = item.product_id;
          $(`[data-flits-product-id=${id}]`).removeClass("flits-wls-inactive");
        });
      },
      error: function (xhr, ajaxOptions, thrownError) {},
    });

    return false;
  }

  $("#wizzy-search-form").on("submit", function () {
    if(isMobile){
    //  $('.wizzy-search-back')[0].click();
    }
    document.documentElement.scrollTop = 0;
    // alert("Hello")
  });
};
